import React, { useState, useEffect } from "react";
import { useCreateBookingStore } from "../../../../store";
import PhoneNumber, {
  defaultCountryOptions,
} from "../../../../Components/Input/PhoneNumber";

export default function PhoneAnswer({ questionId, required, mode }) {
  const setTextAnswer = useCreateBookingStore((state) => state?.setTextAnswer);
  const updateTextAnswer = useCreateBookingStore(
    (state) => state.updateTextAnswer
  );
  const surveyAnswers = useCreateBookingStore((state) => state?.surveyAnswers);
  const summary = useCreateBookingStore((state) => state.summary);

  const initialFull =
    mode === "reschedule"
      ? summary?.surveys[questionId]?.answer[0] || ""
      : surveyAnswers[questionId] || "";

  const initialCountry =
    defaultCountryOptions.find((o) => initialFull.startsWith(o.dial)) ||
    defaultCountryOptions[1];
  const initialNumber = initialFull.startsWith(initialCountry.dial)
    ? initialFull.slice(initialCountry.dial.length)
    : "";

  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const [number, setNumber] = useState(initialNumber);

  useEffect(() => {
    const full = selectedCountry.dial + number;
    if (mode === "reschedule") {
      updateTextAnswer(full, questionId);
    } else {
      setTextAnswer(full, questionId);
    }
  }, [
    selectedCountry,
    number,
    mode,
    questionId,
    setTextAnswer,
    updateTextAnswer,
  ]);

  return (
    <PhoneNumber
      selectedCountry={selectedCountry}
      onSelectCountry={setSelectedCountry}
      number={number}
      onChangeNumber={setNumber}
      required={required}
      borderRadius="20px"
    />
  );
}
